import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@design-system/tokens/breakpoints.css";
import "@design-system/tokens/colors.css";
import "@design-system/tokens/fonts.css";

import App from "./App.tsx";
import { ThemedToastContainer } from "./components/ThemedToastContainer";
import { redirectToLocalhost } from "./utils/redirectToLocalhost";

import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";

// Redirect to localhost in development when accessing from whitelisted hosts
redirectToLocalhost();

// Initialize Sentry only in non-development environments
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE;

if (environment !== "development" && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: environment,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <ThemedToastContainer />
  </StrictMode>,
);
